import { Route } from '@angular/router';

import { fallbackRoutes } from './fallback.routes';
import { globalRoutes } from './global';
import { indvidualRoutes } from './individual.routes';
import { officeRoutes } from './office.routes';

export const appRoutes: Route[] = [...indvidualRoutes, ...officeRoutes, ...globalRoutes, ...fallbackRoutes];
